import { useQuery } from "@apollo/client";
import gql from "graphql-tag";

import { RootPermissions, User } from "gqlTypes";

export const MY_ACCOUNT_FRAGMENT = gql`
  fragment CurrentUserFields on User {
    id
    name
    email
    role
    dev
    devToggles
    twoFactorEnabled
    organizationLinks {
      roles
      organization {
        id
        name
      }
    }
  }
`;
const MY_ACCOUNT_QUERY = gql`
  query myAccount {
    myAccount {
      ...CurrentUserFields
    }
    myPermissions {
      canClearCaches
      canSetAdminBanner
      canAdminSearch
      canExportRecords
      canImportRecords
      canCreateListings
      canAdministerListings
      canViewNonPublicListings
      canViewSensitiveListings
      canCreateOrganizations
      canCreateAdminUsers
      canCreateNonAdminUsers
    }
  }
  ${MY_ACCOUNT_FRAGMENT}
`;

const useMyAccount = () => {
  const { data, ...status } = useQuery<{ myAccount: User; myPermissions: RootPermissions }>(
    MY_ACCOUNT_QUERY,
  );

  if (status.error) throw status.error;

  const account = data?.myAccount ?? null;
  return [account, status] as const;
};

export default useMyAccount;
